export class HtmlSanitizerUtil {
    /**
     * Checks if the provided HTML contains unsafe content such as <script> tags, event handlers, or javascript: URIs.
     */
    static containsUnsafeContent(html: string): boolean { 
      if (!html || html.length === 0) return true;
  
      const scriptTagPattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;
      const eventHandlerPattern = /on\w+=/gi;
      const javascriptUriPattern = /javascript:/gi;
  
      return (
        scriptTagPattern.test(html) ||
        eventHandlerPattern.test(html) ||
        javascriptUriPattern.test(html)
      );
    }
      
    static stripHtml(html: string): string {
      if (!html) return '';
      
      const temp = document.createElement('div');
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || '';
    }

    static stripHtmlWithSpaces(html: string): string {
      // Replace each tag with a space, then normalize whitespace
      return html
        .replace(/<[^>]*>/g, ' ')      
        .replace(/\s+/g, ' ')          
        .trim();                       
    }
    
  }

  
  